import React, { Component } from 'react';
import { Back, Power0, TimelineLite } from 'gsap/all';
import { formatNumber } from 'utils/formatting';
import { isMobileDevice_DEPRECATED } from 'utils/mode';
import ButtonShine from './assets/SpinBtnHilite.json';
import BalanceReloadImg from './assets/Text-BalanceReload@2x.png';
import GoodLuck from './assets/GoodLuck.png';
import './assets/starburst.png';
import './GameBalanceReloadDisplay.css';

class GameBalanceReloadDisplay extends Component {
  constructor(props) {
    super(props);

    this.state = {
      spinStarted: false,
      drawWinAnim: false
    };

    this.renderInteractionArea = this.renderInteractionArea.bind(this);
    this.triggerSpin = this.triggerSpin.bind(this);

    this.buttonShineData = {
      id: 'buttonShine',
      options: {
        loop: true,
        autoplay: true,
        animationData: ButtonShine,
        rendererSettings: {
          preserveAspectRatio: 'xMinYMin meet'
        }
      },
      wrapperClass: 'button-shine'
    };

    this.timeline = new TimelineLite({ paused: true });
    this.button = null;
    this.text = null;
    this.goodLuck = null;

    this.winTimeline = new TimelineLite({ paused: true });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // "reset" when parent component has told us win amount is null after having a valid one
    if (
      prevProps.winAmount !== null &&
      prevProps.winAmount >= 0 &&
      this.props.winAmount == null
    ) {
      this.resetAnimations();
    } else if (prevProps.winAmount === null && this.props.winAmount !== null) {
      this.setState({ drawWinAnim: true });
    } else if (this.state.drawWinAnim && !prevState.drawWinAnim)
      this.animateWin();

    if (!prevProps.beginSpin && this.props.beginSpin) {
      this.animateSpinStart();
    }
  }

  triggerSpin() {
    this.props.startSpin();
    this.setState({ spinStarted: true });
    this.animateSpinStart();
  }

  animateSpinStart() {
    this.timeline.kill().clear().pause(0);
    this.addGoodLuckSwap();
    this.addInteractiveFade();
    this.timeline.play();
  }

  addGoodLuckSwap() {
    this.timeline
      .to(this.text, 0.5, { opacity: 0, ease: Power0.easeNone }, '.25')
      .to(this.goodLuck, 0.5, { opacity: 1, ease: Power0.easeNone }, '.8');
  }

  addInteractiveFade() {
    this.timeline.to(
      this.goodLuck,
      0.66,
      { opacity: 0, ease: Power0.easeNone },
      '3.5'
    );
  }

  animateWin() {
    this.winTimeline
      .to(
        this.result,
        0.5,
        { scale: 1, ease: Back.easeOut.config(1.75) },
        '0.25'
      )
      .to(this.win, 1, { scale: 1, ease: Back.easeOut.config(1.75) }, '0.5')
      .play();
  }

  resetAnimations() {
    this.winTimeline.restart().kill().clear().pause(0);
    this.timeline.restart().kill().clear().pause(0);
    this.setState({ spinStarted: false, drawWinAnim: false });
  }

  renderInteractionArea() {
    return (
      <div
        className="interactive-result"
        ref={div => this.props.setButtonArea(div)}
      >
        {this.renderWinArea()}
      </div>
    );
  }

  renderWinArea() {
    let winInt = parseInt(this.props.winAmount, 10);

    return (
      <div className="result-info">
        <div className="result-text" ref={div => (this.result = div)}>
          You Win!
        </div>
        <div className="result-number" ref={div => (this.win = div)}>
          {
            !isNaN(winInt) && (
              <span>{formatNumber(winInt) + '!'}</span>
            ) /* Don't display NaN */
          }
        </div>
      </div>
    );
  }

  renderMobileFooter() {
    return <div className="wscore-wheel-mobile-footer"></div>;
  }

  render() {
    const actionText = (
      <React.Fragment>
        Keep playing to win prizes that can be redeemed at Wind Creek casinos.
        <br />
        <br />
        <div className="footer-action-text">
          Spin the wheel to receive credits!
        </div>
      </React.Fragment>
    );

    return (
      <div className="game-balance-reload-display">
        <div className="title" ref={this.props.setTitle}>
          <img src={BalanceReloadImg} alt="Balance Reload" />
        </div>
        <div className="banner-text" ref={this.props.setHeader}>
          Thank you for playing at Wind Creek Casino!
        </div>
        <div className="text-area">
          <div
            className="action-call"
            ref={div => {
              this.text = div;
              this.props.setText(div);
            }}
          >
            {actionText}
          </div>
          <div className="good-luck" ref={div => (this.goodLuck = div)}>
            <img src={GoodLuck} alt="Good Luck!" />
          </div>
        </div>
        {this.renderInteractionArea()}
        {isMobileDevice_DEPRECATED() && this.renderMobileFooter()}
      </div>
    );
  }
}

export default GameBalanceReloadDisplay;
